export default "__VITE_ASSET__FYxkMkzN__"